<div class="main">
  <h6>Información</h6>
  <p>En los siguientes pasos vas a configurar este documento: firmantes, contenido, verificaciones, etc.</p>
  <h6>Instrucciones</h6>
  <p>{{text}}</p>

</div>


